import React from 'react';
import { Badge, createStyles, makeStyles, Tab, Typography } from '@material-ui/core';
import Colors from '~/styles/colors';

interface Props {
  title: string;
  badgeContent?: React.ReactNode;
}

const useStyles = makeStyles(() =>
  createStyles({
    badge: {
      position: 'absolute',
      top: 10,
      right: 18,
      '& span': {
        color: Colors.white,
        fontWeight: 'bold',
      },
    },
  }),
);

export const OpportunityTab = ({ title, badgeContent, ...rest }: Props) => {
  const classes = useStyles();

  return (
    <Tab
      style={{ minWidth: 100, padding: '6px 14px' }}
      label={
        <>
          <Badge badgeContent={badgeContent} color='primary' className={classes.badge} />
          <Typography style={{ fontSize: 13 }}>{title}</Typography>
        </>
      }
      {...rest}
    />
  );
};
